<template>
  <form ref="form">
    <slot />
  </form>
</template>

<script setup lang="ts">

import { FormValidator, FormValidatorModel } from "@syncfusion/ej2-vue-inputs";
import { onMounted, ref } from "vue";
import SogFormValidationRule from "@/shared/ui/types/SogFormValidationRule";

interface Props {
  validations?:SogFormValidationRule[]
}

const props = withDefaults(defineProps<Props>(),{validations:undefined}

)


const form = ref<HTMLFormElement|undefined>(undefined)

const options: FormValidatorModel = {
  customPlacement: function(inputElement, errorElement) {
    const inputErrorElement = inputElement.closest('.sog-form-field').querySelector('.error');
    inputErrorElement.parentElement.appendChild(errorElement);
  },
  rules:{
    //'Name':{    required: true}
  }
}

let formValidator : FormValidator|undefined = undefined

const validate = ( ):boolean => {
  if(formValidator)
    return formValidator.validate();
  return false;
}

const addRules = (rule:SogFormValidationRule)=>{
      formValidator?.addRules(rule.name, rule.rules)
}

const removeRules = (name:string)=>{
    formValidator?.removeRules(name)
}


onMounted(()=>{
  if(form.value) {
    formValidator = new FormValidator(form.value, options);

    if (props.validations && props.validations.length>0) {
      props.validations.forEach(v => {
        formValidator?.addRules(v.name, v.rules)
      })
    }

  }
})


defineExpose({
  validate,addRules,removeRules
})

</script>

<style scoped>

</style>
